const isHavaianas = {
    computed: {
      isHavaianas: function () {
        const user = JSON.parse(localStorage.getItem('user') || {});
        const havainas = user.customer && user.customer.marcasDaFranquia && user.customer.marcasDaFranquia[0] === 39;
        console.log(havainas);
        return havainas;
      }
    },
  }

export default isHavaianas